import { UpdateUserRequestBody } from "@syla/shared/types/requests/UpdateUserRequestBody";
import axios from "axios";

import { User } from "../../types/user/user";

export async function updateUser(
  newProps: UpdateUserRequestBody,
): Promise<User> {
  const response = await axios.patch("/users", newProps);
  return response.data;
}
